export default __webpack_public_path__ + "static/media/Arm-straps of the Unutterable.cd5b3af3.jpg";